import React, {useContext, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import MyButton from "../UI/MyButton/MyButton";
import classes from '../UI/MyButton/MyButton.module.css';
import OrderService from "../services/OrderService";
import {toJS} from "mobx";
import {Context} from "../index";
import DemandService from "../services/DemandService";
import {Button} from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function EntityItem(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const {store} = useContext(Context);
    const [showFinalStatusDialog, setShowFinalStatusDialog] = useState(false);
    const [finalStatusMessage, setFinalStatusMessage] = useState('');
    const {onEntityRemoved} = props;

    const handleSetEntityCurrentTrue = () => {
        const entityId = props.entity.id;

        // Update local MobX store for immediate UI feedback
        const currentEntities = toJS(store.entitiesInWork).map(item => {
            if (item.id === entityId) {
                item.current = true;
            }
            return item;
        });
        store.setEntitiesInWork(currentEntities);

        // Navigate to entity page (API call will be made by the target page)
        if (store.positionKey === 'assembler') {
            navigate(`/orders/${entityId}`);
        } else if (store.positionKey === 'packer') {
            navigate(`/demand/${entityId}`);
        }
    }

    const handleConfirmFinalStatus = async () => {
        const entityId = props.entity.id;

        const updatedEntities = toJS(store.entitiesInWork).filter(item => item.id !== entityId);
        await store.setEntitiesInWork(updatedEntities);

        await store.checkEntitiesInWork();

        if (onEntityRemoved) {
            setTimeout(() => {
                onEntityRemoved();
            }, 100);
        }

        setShowFinalStatusDialog(false);
    }

    const handleSetEntityInWork = async () => {
        const entityId = props.entity.id;
        const currentEntities = toJS(store.entitiesInWork);

        if (store.positionKey === 'assembler') {
            const newOrder = await OrderService.getNewOrder({orderId: entityId}).then(data => data.data);
            currentEntities.push(newOrder);
            store.setEntitiesInWork(currentEntities);
            navigate(`/orders/${newOrder.id}`);
        } else if (store.positionKey === 'packer') {
            const newDemand = await DemandService.getNewDemand({demandId: entityId}).then(data => data.data);
            currentEntities.push(newDemand);
            store.setEntitiesInWork(currentEntities);
            navigate(`/demand/${newDemand.id}`);
        }
    }

    return (
        <div>
            {showFinalStatusDialog && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 99999
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '8px',
                        maxWidth: '500px',
                        width: '90%',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
                    }}>
                        <h3 style={{marginTop: 0, marginBottom: '15px'}}>{t('msg.attention')}</h3>
                        <p style={{marginBottom: '20px', fontSize: '16px'}}>{finalStatusMessage}</p>
                        <Button onClick={handleConfirmFinalStatus} variant="contained" color="primary">
                            {t('btn.ok')}
                        </Button>
                    </div>
                </div>
            )}

            {props.entity.hasOwnProperty('isAvailable') ?
                props.entity.isAvailable ?
                        <div>
                            <MyButton className={classes.myBtnAvailable}
                                      onClick={handleSetEntityInWork}> {props.entity.name} </MyButton> <span>{t('msg.available')}</span>
                        </div>
                        :
                    <div>
                        <MyButton className={classes.myBtnNotAvailable}> {props.entity.name} </MyButton> <span>{t('msg.unavailable')}</span>
                    </div>
                :
                props.entity.waiting ?
                        <div>
                            <MyButton className={classes.myBtnWaiting}
                                      onClick={handleSetEntityCurrentTrue}> {props.entity.customerorderName} {props.entity.name} </MyButton> {props.entity.waiting}
                        </div>
                        :
                        props.entity.correct ?
                        <div>
                            <MyButton className={classes.myBtnCorrect}
                                      onClick={handleSetEntityCurrentTrue}> {props.entity.customerorderName} {props.entity.name} </MyButton> {props.entity.correct}
                        </div>
                        :
                        <div>
                            <MyButton className={classes.myBtn}
                                      onClick={handleSetEntityCurrentTrue}> {props.entity.customerorderName} {props.entity.name} </MyButton>
                        </div>
            }
            <div>
            </div>
        </div>
    )
}


